'use strict'

const flow_ = require('lodash/flow')
const curry_ = require('lodash/curry')

const { assign, bind } = require('./utils')
const { freshCollection } = require('./collections')

// freshStore :: (MainCollectionName, FieldToReferencedCollectipnsMap) -> Store
const freshStore = mainCollectionName =>
  Object.assign(
    {},
    {
      [mainCollectionName]: Object.assign({}, freshCollection())
    }
  )

// setCollection :: (ReferenceFieldName, Collection) -> Store -> Store
const setCollection = curry_((name, collection) =>
  assign({ [name]: collection })
)

// getCollection :: CollectionName -> Store -> Collection
const getCollection = collectionName => store => store[collectionName]

// updateCollectionStore :: (CollectionName, Collection -> Collection) -> Store -> Store
const updateCollection = curry_((collectionName, updateFn) =>
  bind(
    flow_(getCollection(collectionName), updateFn),
    setCollection(collectionName)
  )
)

module.exports.freshStore = freshStore
module.exports.getCollection = getCollection
module.exports.setCollection = setCollection
module.exports.updateCollection = updateCollection



// WEBPACK FOOTER //
// ./recordStore/store.js